import { UseRolesParams } from "PFCore/hooks/queries/roles/use_roles";
import { FetchAuditRolesParams, FetchManageViewRolesParams, FetchRolesParams } from "PFCore/services/roles";

export const rolesKeys = {
  all: () => ["roles"],
  list: (params: UseRolesParams) => [...rolesKeys.all(), "list", params],
  index: (params: FetchRolesParams) => [...rolesKeys.all(), "index", params],
  manageViewAll: () => [...rolesKeys.all(), "manageView"],
  manageView: (params: FetchManageViewRolesParams) => [...rolesKeys.manageViewAll(), params]
};

export const auditRolesKeys = {
  all: () => ["auditRoles"],
  list: (params: FetchAuditRolesParams) => [...auditRolesKeys.all(), params],
  bySearchId: (searchId: number) => [...auditRolesKeys.all(), "searchId", searchId]
};
